import axios from "axios";

// Set config defaults when creating the instance
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
});

// Alter defaults after instance has been created
axiosInstance.defaults.headers.common["Authorization"] = "AUTH_TOKEN";
